import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z"/>',
  f: '<path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Z"/>',
  rao: { fill: '#5f6368' },
  raf: { fill: '#5f6368' },
};

export default data;
